import Reveal from "@/components/feature/Reveal";
import { timelineItems } from "@/mocks/homeData";

export default function Timeline() {
  return (
    <section id="timeline" className="w-full px-4 md:px-10 py-16 md:py-24 bg-background-50">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-4">
          <Reveal>
            <p className="font-label text-xs md:text-sm tracking-[0.24em] text-primary-600">更新节奏</p>
            <h2 className="mt-4 font-heading font-black text-2xl md:text-4xl text-foreground-950">
              什么时候补了什么材料
            </h2>
            <p className="mt-4 font-body text-sm md:text-base leading-7 text-foreground-600">
              新增、核对、转写、归档都会留痕。节奏放慢，是为了每份材料都能说清来源。
            </p>

            <div className="mt-8 rounded-lg border border-background-200 bg-background-100 p-5">
              <p className="font-label text-xs text-foreground-500">本周整理概况</p>
              <div className="mt-4 flex items-end gap-3">
                <span className="font-heading font-black text-3xl text-foreground-950">168</span>
                <span className="pb-1 font-label text-sm text-foreground-600">份材料新增</span>
              </div>
              <div className="mt-4 h-2 w-full rounded-full bg-background-200 overflow-hidden">
                <div className="h-full w-2/3 rounded-full bg-accent-500"></div>
              </div>
              <p className="mt-3 font-label text-xs text-foreground-500">已核对 112 份 · 待核对 56 份</p>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-8">
          <ol className="relative border-l border-background-300 pl-6 md:pl-10 flex flex-col gap-9 md:gap-11">
            {timelineItems.map((item, index) => (
              <Reveal key={item.id} as="li" delay={index * 50} className="relative">
                <span
                  className="absolute -left-[31px] md:-left-[47px] top-1.5 w-3.5 h-3.5 rounded-full bg-background-50 border-2 border-accent-500"
                  aria-hidden="true"
                ></span>
                <div className="flex flex-wrap items-center gap-3">
                  <span className="font-label text-sm text-foreground-500">{item.time}</span>
                  <span className="inline-flex items-center rounded-full bg-accent-100 px-3 py-1 font-label text-xs text-accent-900">
                    {item.tag}
                  </span>
                </div>
                <h3 className="mt-3 font-heading font-bold text-lg md:text-xl text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2 font-body text-sm md:text-base leading-7 text-foreground-600">{item.desc}</p>
              </Reveal>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}